import { FormEvent } from 'react';
import { Nav } from "react-bootstrap";
import { NavWrapper, NavItemWrapper } from "./styles";
import { OrganType } from '@nkr/enums/organ-type';

interface IProps {
    activeKey: string,
    centerId: number,
    isAdmin: boolean,
    isMicrositeParticipant: boolean,
    isFollowUpParticipant: boolean,
    isInDonorShield: boolean,
    organType: OrganType,
    onTabSelect: (key: string) => void
}

const DonorsNav = (props: IProps) => {
    const handleSelect = (e: FormEvent<Nav>) => {
        props.onTabSelect(e['eventKey']);
    };

    const { activeKey, centerId, isAdmin, isMicrositeParticipant, isFollowUpParticipant, isInDonorShield } = props;

    const hrefPrefix = isAdmin ? '/admin' : `/center/${centerId}`;

    const isNkr = props.organType == OrganType.Kidney;

    const tabs = [
        { eventKey: 'SEARCH', href: !isAdmin ? `${hrefPrefix}/donors/search` : 'admin/donors', label: <>Donor Search</>, show: isNkr },
        { eventKey: 'DASHBOARD', href: `${hrefPrefix}/reports/dash-board/summary`, label: <>DASHboard</>, show: true },
        { eventKey: 'MICROSITES', href: `${hrefPrefix}/microsite/pending-center`, label: <>Microsites</>, show: isMicrositeParticipant || isAdmin },
        { eventKey: 'DONOR-INTAKE', href: `${hrefPrefix}/donors/donor-intake/to-do`, label: <>Donor Intake</>, show: !isAdmin },
        { eventKey: 'SWAP', href: `${hrefPrefix}/donors/swap`, label: <>Swap Donors</>, show: props.organType == OrganType.Kidney },
        { eventKey: 'DONOR-SHIELD-DIRECT', href: `${hrefPrefix}/donors/donor-shield-direct/pending-transplant`, label: <>Donor Shield Direct</>, show: isInDonorShield },
        { eventKey: 'WAGE-AND-TRAVEL', href: !isAdmin ? `${hrefPrefix}/donors/watr` : `${hrefPrefix}/dash/watr`, label: <>Donor Shield Claims</>, show: true },
        { eventKey: 'VOUCHER-PROGRAM', href: `${hrefPrefix}/donors/voucher-program`, label: <>Voucher Program</>, show: !isAdmin && isNkr },
        { eventKey: 'DONOR-FOLLOW-UP', href: `${hrefPrefix}/follow-up/surveys`, label: <>Donor Follow-Up</>, show: (isFollowUpParticipant || isAdmin) && isNkr },
        { eventKey: 'RECONCILIATION', href: `${hrefPrefix}/donors/reconciliation`, label: <>Donor Reconciliation</>, show: !isAdmin && isNkr },
        { eventKey: 'PROFILE', href: `${hrefPrefix}/donors/reconciliation`, label: <>Donor Profile</>, show: props.activeKey == 'PROFILE' },
        { eventKey: 'ADD', href: `${hrefPrefix}/donor/add`, label: <>Add Donor/Recipient</>, show: props.activeKey == 'ADD' },
    ]

    return (
        <NavWrapper bsStyle="tabs" activeKey={activeKey} onSelect={handleSelect}>
            {tabs.filter(x => x.show).map((tab, index) =>
                <NavItemWrapper key={'donor-tab-' + index} eventKey={tab.eventKey} href={tab.href}>
                    {tab.label}
                </NavItemWrapper>
            )}
        </NavWrapper>
    );
}

export default DonorsNav;